<template>
  <div class="jobfair-detail">
    <side-bar>
      <header-nav ref="router" theme="1"></header-nav>
      <base-login @logined="init"></base-login>
      <el-container class="container" v-loading="!jobfairInfo.video_jobfair_id">
        <el-main>
          <card-base :style-object="style.top" :margin-object="style.topMargin">
            <el-row :gutter="15" style="height: 1.85rem">
              <el-col :span="8" style="height: 100%; padding: 0.15rem">
                <el-image
                    style="width: 100%; height: 100%"
                    :src="jobfairInfo.img"
                    fit="cover"
                    lazy
                >
                  <div slot="placeholder" class="image-slot">
                    加载中
                    <span class="dot">...</span>
                  </div>
                  <div slot="error" class="image-slot">
                    <el-image
                        style="width: 100%; height: 100%"
                        :src="$util.error_img_jobfair"
                        fit="cover"
                    ></el-image>
                  </div>
                </el-image>
              </el-col>
              <el-col :span="16">
                <div class="top-top">
                  <p class="title">
                    <i class="iconfont iconIcon-shipin"></i>
                    <span>{{ jobfairInfo.name }}</span>
                    <el-button
                        size="mini"
                        :type="
                        jobfairInfo.current_status !== '已结束' ? 'primary' : ''
                      "
                        plain
                    >
                      {{ jobfairInfo.current_status }}
                    </el-button>
                  </p>
                  <p class="des">
                    <span>{{ jobfairInfo.city }}</span>
                    <span>{{ jobfairInfo.start_time }} - {{ jobfairInfo.end_time }}</span>
                  </p>
                </div>
                <el-row :gutter="15" class="top-content">
                  <el-col :span="16" class="list">
                    <ul>
                      <li v-if="jobfairInfo.organizers">
                        <span>主办方:{{ jobfairInfo.organizers }}</span>
                      </li>
                      <li v-if="jobfairInfo.host_organizers">
                        <span>承办方:{{ jobfairInfo.host_organizers }}</span>
                      </li>
                      <li v-if="jobfairInfo.co_organizer">
                        <span>协办方:{{ jobfairInfo.co_organizer }}</span>
                      </li>
                      <li class="flex-box">
                        <p>
                          <span class="iconfont iconqiye1"></span>
                          <!-- <span v-if="jobfairInfo.nums_text">预计参加企业：{{ jobfairInfo.nums_text }}</span> -->
                          <span>预计参加单位/人数：{{ jobfairInfo.nums ? jobfairInfo.nums * 1 + '家' : '' }} |
                            {{ jobfairInfo.stu_numb ? jobfairInfo.stu_numb * 1 + '人' : '' }}</span>
                        </p>
                        <p v-if="jobfairInfo.educations"><span>学历：{{ jobfairInfo.educations || '' }}</span></p>
                      </li>
                    </ul>
                  </el-col>
                  <el-col :span="8" class="tr btn" v-if="jobfairInfo.video_jobfair_id">
                    <div class="into-btn-box">
                      <div v-if="jobfairInfo.current_status !== '已结束'">
                        <el-button
                            type="primary"
                            v-if="register"
                            @click="toCompanyHall"
                        >进入会场
                        </el-button
                        >
                        <el-button type="primary" v-else @click="signup"
                        >报名进入会场
                        </el-button
                        >
                      </div>
                      <div v-else>
                        <el-button
                            type="primary"
                            v-if="register"
                            @click="toCompanyHall"
                        >进入会场
                        </el-button
                        >
                      </div>
                      <div class="views-nums"><span class="iconfont icon-yanjing1"></span>{{ jobfairInfo.view_nums || 0 }}
                      </div>
                    </div>
                    
                    
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </card-base>
          <card-base :style-object="style.content">
            <el-row
                class="jobfair-count"
                :style="{ width: count_config.width }"
            >
              <el-col class="tc" :span="count_config.span">
                <p>{{
                    jobfairInfo.company_count && jobfairInfo.company_count.approve_count ? jobfairInfo.company_count.approve_count : 0
                  }}</p>
                <span>企业数</span>
              </el-col>
              <el-col :span="count_config.span">
                <p>{{ jobfairInfo.post_count || 0 }}</p>
                <span>职位数</span>
                <!-- 职位的数量，不算人 -->
              </el-col>
              <el-col :span="count_config.span">
                <p>{{ jobfairInfo.job_number || 0 }}</p>
                <span>岗位数</span>
                <!-- 所有职位的人数加起来，人更多 -->
              </el-col>
              <el-col :span="count_config.span">
                <p>{{ jobfairInfo.seeker_numbs || 0 }}</p>
                <span>求职人数</span>
              </el-col>
            </el-row>
            <div class="jobfair-desc">
              <div v-if="jobfairInfo.jobfair_desc" class="text-sm-title">
                双选会说明:
              </div>
              <div
                  v-if="jobfairInfo.jobfair_desc"
                  class="text-sm jobfair-desc-text"
                  v-html="jobfairInfo.jobfair_desc"
              ></div>
              <div
                  v-if="jobfairInfo.seeker_register_desc"
                  class="text-sm-title"
                  style="margin-top: 15px"
              >
                求职者报名说明:
              </div>
              <div
                  v-if="jobfairInfo.seeker_register_desc"
                  class="text-sm jobfair-desc-text"
                  v-html="jobfairInfo.seeker_register_desc"
              ></div>
            </div>
          </card-base>
        </el-main>
      </el-container>
      <footer-box></footer-box>
    </side-bar>
    <el-dialog
        :visible.sync="dialog_password.is_show_dialog"
        width="420px"
        center
        :show-close="true"
    >
      <div>
        <el-input
            placeholder="请输入内容"
            v-model="enterForm.pass"
            @keyup.native.enter="submitForm"
        >
          <template slot="prepend">入场密码</template>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_password.is_show_dialog = false"
        >取 消</el-button
        >
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CardBase from '@/components/Card/CardBase'

export default {
  name: 'jobfair-detail',
  components: {CardBase},
  computed: {},
  data () {
    return {
      count_config: {
        span: 6,
        width: '1000px',
      },
      style: {
        top: {
          padding: '0.28rem 0.6rem 0.12rem 0.25rem',
        },
        topMargin: {
          marginBottom: '0.2rem',
        },
        content: {
          padding: '0.4rem',
        },
      },
      video_jobfair_id: 0,
      jobfairInfo: {},
      register: false,

      dialog_password: {
        is_show_dialog: false,
      },
      enterForm: {
        pass: '',
      },
    }
  },
  mounted: function () {
    this.init()
  },
  methods: {
    init: function () {
      var video_jobfair_id = this.$util.getQueryString('video_jobfair_id')

      if (!video_jobfair_id) {
        // 返回视频双选会列表页面
        this.$util.pageto('jobfair')
        return
      }

      this.video_jobfair_id = video_jobfair_id
      this.getDetail()
    },
    getDetail: function () {
      var _self = this
      var video_jobfair_id = this.video_jobfair_id

      this.$util
          .get('kzp_video_jobfair', 'video_jobfair_detail', {
            video_jobfair_id: video_jobfair_id,
          })
          .then((res) => {
            if (res.code !== 1) {
              var err_msg = res.msg || '获取详情信息失败, 点击确定回到双选会页'
              // _self.$message.error(err_msg);
              _self.$alert(err_msg, '提示', {
                confirmButtonText: '确定',
                type: 'warning',
                showCancelButton: false,
                callback: (action) => {
                  // 回到双选会列表页
                  _self.$util.pageto('jobfair')
                },
              })
              return
            }

            var data = res.data
            if (data && data.detail) {
              var jobfairInfo = data.detail
              _self.$util.tansPics(jobfairInfo, 'img')
              jobfairInfo.jobfair_desc = _self.$util.filterRichText(
                  jobfairInfo.jobfair_desc
              )
              jobfairInfo.seeker_register_desc = _self.$util.filterRichText(
                  jobfairInfo.seeker_register_desc
              )

              _self.jobfairInfo = jobfairInfo

              if (data.register) {
                _self.register = data.register
              }
            }
          })
    },
    toCompanyHall: function () {
      var video_jobfair_id = this.video_jobfair_id
      // this.$message({
      //   message: "即将进入企业大厅",
      //   type: "success"
      // });
      this.$util.pageto('jobfair_company', {
        video_jobfair_id: video_jobfair_id,
      })
    },
    submitForm: function () {
      var _self = this

      if (_self.enterForm.pass.length <= 0) {
        _self.$message.error('请先输入入场密码!')
        return
      }

      _self.registerVideoJobfair()
    },
    signup: function () {
      // 检查求职者是否登录
      if (!this.$util.checkLogin()) {
        this.$message.error('请先登录!')
        return
      }

      var jobfairInfo = this.jobfairInfo
      // 是否需要密码？学校设置了密码
      if (jobfairInfo.password) {
        //   输入入场密码
        this.dialog_password.is_show_dialog = true
        return
      }

      this.registerVideoJobfair()
    },
    registerVideoJobfair: function () {
      var _self = this
      //   register_video_jobfair
      this.$util
          .post('kzp_video_jobfair', 'register_video_jobfair', {
            video_jobfair_id: _self.video_jobfair_id,
            password: _self.enterForm.pass,
          })
          .then((res) => {
            const {
              code, msg, data
            } = res
            if (code !== 1) {
              if (msg && data && msg.indexOf('完善简历') > -1) {
                _self.$confirm(msg, '提示', {
                  confirmButtonText: '去完善',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  // 去完善简历
                  _self.$refs['router'].subpageto(
                      'resume',
                      {resumes_id: data}
                  )
                }).catch(() => {
                  // 关掉弹窗
                })
              } else {
                var err_msg = msg || '报名失败!'
                _self.$message.error(err_msg)
              }
              return
            }

            _self.register = true
            _self.toCompanyHall()
          })
          .catch(() => {
            // 处理不提示的错误!
          })
    },
  },
}
</script>

<style lang="scss" scoped>
.jobfair-detail {
  height: 100%;

  .el-container {
    padding: 0.2rem 0;

    .el-aside,
    .el-main {
      overflow: visible;
    }
  }

  .top-top {
    padding: 0.2rem 0 0.04rem;

    .title {
      color: #171717;
      font-weight: bold;
      font-size: 0.18rem;
      line-height: 0.25rem;
      margin-bottom: 0.05rem;

      .iconfont {
        color: #439bff;
        margin-right: 0.02rem;
        font-size: 0.2rem;
      }
    }

    .des {
      font-size: 0.14rem;
      color: #999;
      line-height: 1.5;

      > span {
        margin-right: 0.2rem;
      }
    }
  }

  .top-content {
    .list {
      padding-top: 5px;

      li {
        color: #171717;
        font-size: 0.14rem;
        line-height: 0.2rem;
        margin-bottom: 0.05rem;
      }
    }
  }

  .text-sm-title {
    font-size: 0.18rem;
    line-height: 0.25rem;
    color: #282828;
  }

  .jobfair-count {
    margin: 0 auto;
    text-align: center;

    p {
      color: #439bff;
      font-size: 0.4rem;
      font-weight: bold;
      line-height: 0.47rem;
    }

    span {
      font-size: 0.16rem;
      line-height: 0.22rem;
      color: #999;
      font-weight: 400;
    }
  }

  .jobfair-desc {
    text-align: left;
    padding-top: 0.4rem;

    img {
      max-width: 100%;
      height: auto;
    }

    .jobfair-desc-text {
      @include over-wrap();
    }
  }

  .flex-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    flex-wrap: nowrap;
  }

  .views-nums {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    width: 100%;
    float: right;
    font-size: 14px;
    color: #555;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    span {
      margin-right: 5px;
    }

    .icon-yanjing1 {
      font-size: 18px;
    }
  }
  .into-btn-box{
    text-align: center;
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/seeker/jobfair/detail/App.vue